<template>
    <translates
        :item="this.categ"
        :item_id="parseInt(categ.id)"
        item_type="category">
    </translates>
</template>

<script>
import translates from "../../../../translates/translates";

export default {
    name: "categ_translate",
    components: {
        translates
    },
    props : {
        categ : {
            type : Object
        }
    },
}
</script>

<style scoped>

</style>
